import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Stars } from '@catalogo/theme-stars';
import { Nav } from '@catalogo/core-nav';
import withFilter from '@catalogo/service-americanas-product-review/src/legacy/hocs/withFilter';
import FilterInput from './filter-input';

const RenderFeedbackNoReview = ({ starCountFeedback, onChangeRating }) => (
  <FeedbackWrapper>
    <TextFeedback>O produto não possui nenhuma avaliação {starCountFeedback}</TextFeedback>
    <ButtonFeedbackFilter onClick={() => onChangeRating({ filter: null, name: 'todas as notas', label: '' })}>
      veja todas as avaliações
    </ButtonFeedbackFilter>
  </FeedbackWrapper>
);

export const RatingDistribution = ({ stateRating, ratingDistribution, onChangeRating, ratingsOptions }) => (
  <RatingList>
    {[5, 4, 3, 2, 1].map(item => {
      const getFilter = ratingsOptions.find(filter => filter.rating === item);
      const filteredItemWithEventAction = { ...getFilter, eventAction: 'Avaliações -  Tabela de distribuição' };
      const active = stateRating.rating === getFilter.rating;
      return (
        <RatingListItem key={item}>
          <StarsUI rating={item} size={20} />
          <StarsCount active={active} onClick={() => onChangeRating(filteredItemWithEventAction)}>
            {ratingDistribution[`rating${item}`].count}
          </StarsCount>
        </RatingListItem>
      );
    })}
  </RatingList>
);

const PercentageReviews = ({ percentageReviews }) => (
  <div>
    <WrapperPercentage>
      <LabelRecommended>{percentageReviews}%</LabelRecommended>
      <TextRecommended>dos clientes recomendam este produto</TextRecommended>
    </WrapperPercentage>
  </div>
);

const RatingPercentage = ({ rating }) => (
  <Wrapper>
    <RatingValue>{Number(rating?.average).toFixed(1)}</RatingValue>
    <Stars rating={rating?.average} size={30} />
    <ReviewsValue>
      baseada em {rating?.reviews} avaliaç{rating?.reviews > 1 ? 'ões' : 'ão'}
    </ReviewsValue>
  </Wrapper>
);

export const Header = ({
  rating,
  ratingDistribution,
  recommended,
  onChangeSort,
  onChangeRating,
  sortOptions,
  ratingsOptions,
  starCountFeedback,
  stateRating,
  stateSort,
  setFilterLoadMore,
  reviews,
  productId,
}) => {
  useEffect(() => {
    setFilterLoadMore(stateRating.filter, stateSort.filter);
  }, [stateRating, stateSort]);

  return (
    <>
      <WrapperHeader>
        <RatingPercentage rating={rating} />
        <WrapperRecommended>
          <RatingDistribution
            ratingDistribution={ratingDistribution}
            onChangeRating={onChangeRating}
            ratingsOptions={ratingsOptions}
            stateRating={stateRating}
          />
          <PercentageReviews percentageReviews={recommended} />
        </WrapperRecommended>
        <WrapperButton>
          <Button to={`/avaliacao/${productId}`}>Avaliar produto</Button>
          <WrapperFilters>
            <FilterInput
              name="filter-rating"
              stateRating={stateRating}
              filters={ratingsOptions}
              onChange={onChangeRating}
              width={150}
            />
            <FilterInput name="filter-sort" filters={sortOptions} onChange={onChangeSort} />
          </WrapperFilters>
        </WrapperButton>
      </WrapperHeader>
      {reviews.length < 1 && (
        <RenderFeedbackNoReview starCountFeedback={starCountFeedback} onChangeRating={onChangeRating} />
      )}
    </>
  );
};

export default withFilter(Header);

Header.propTypes = {
  rating: PropTypes.object,
  productId: PropTypes.string,
  recommended: PropTypes.number,
  hasReviews: PropTypes.bool,
  fetchMore: PropTypes.func,
};

const WrapperRecommended = styled.div`
  display: flex;
  flex: 0.5;
`;

const WrapperFilters = styled.div`
  display: flex;
  margin-top: 37px;
`;

const WrapperPercentage = styled.div`
  display: flex;
  padding-top: 2px;
`;

const TextRecommended = styled.span`
  font-size: 14px;
  width: 142px;
  line-height: 1rem;
`;

const LabelRecommended = styled.div`
  display: flex;
  background: #ffc900;
  padding: 0 12px;
  color: #000;
  font-size: 18px;
  font-weight: 700;
  margin-right: 23px;
  align-items: center;
`;

const WrapperHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 16px;
`;

const Wrapper = styled.div`
  display: block;
  flex-direction: column;
  color: ${({ theme }) => theme.grey.medium};
`;

const WrapperButton = styled.div`
  display: flex;
  width: 350px;
  flex-direction: column;
  align-items: flex-end;
`;

const ReviewsValue = styled.span`
  color: ${({ theme }) => theme.grey.dark};
  margin-top: 10px;
  font-size: 18px;
  display: block;
`;

const RatingValue = styled.span`
  font-weight: 700;
  font-size: 64px;
  color: #4e4e4e;
  display: block;
`;

const Button = styled(Nav)`
  border: 2px solid ${({ theme }) => theme.primaryColor};
  border-radius: 8px;
  padding: 12px 15px 11px;
  background: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.primaryColor};
  font-size: 16px;
  outline: 0;
  text-transform: ${({ theme }) => theme.btnTextTransform};
`;

const RatingList = styled.ul`
  border-right: 1px solid #ccc;
  padding-right: 30px;
  margin-right: 30px;
`;

const RatingListItem = styled.li`
  display: flex;
  align-items: flex-end;
  text-decoration: underline;
  margin-bottom: 7px;
  align-items: center;
  font-size: 14px;
`;

const StarsUI = styled(Stars)`
  margin-right: 10px;
  background: red;
`;

const StarsCount = styled.button`
  margin-left: 12px;
  background: none;
  outline: none;
  border: none;
  cursor: pointer;
  color: #666;
  text-decoration: underline;
  color: ${({ active }) => (active ? `#000` : `#666`)};
  ${({ active }) => active && `font-weight: 600`}
`;

const FeedbackWrapper = styled.div`
  text-align: center;
  padding-top: 30px;
  margin: 15px 16px 0 16px;
  padding: 72px 0;
  border-top: 1px solid #ccc;
`;

const ButtonFeedbackFilter = styled.span`
  font-size: 20px;
  text-align: center;
  display: block;
  margin-top: 20px;
  text-decoration: underline;
  cursor: pointer;
`;

const TextFeedback = styled.span`
  text-align: center;
  display: block;
  font-size: 23px;
  font-weight: 600;
  transform: ${({ theme }) => theme.btnTextTransform};
`;
